module.exports = __webpack_public_path__ + "static/media/Marienberg19.f477869d.jpg";